// Email validation function
export const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const validateEmails = (emailArray)=>  {
    // Define a regular expression for validating an email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // console.log("emailString",emailString)
  
    // Split the email string by commas and trim any whitespace
    // const emailArray = emailString.split(',').map(email => email.trim());
  
    // Validate each email
    const invalidEmails = emailArray.filter(email => !emailRegex.test(email));
  
    if (invalidEmails.length > 0) {
        return false;
     /*  return {
        isValid: false,
        invalidEmails: invalidEmails, // Return the invalid emails
      }; */
    }
    return true;
    // return { isValid: true, invalidEmails: [] }; // All emails are valid
  }

  const mimeTypeToExtension = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',  // Excel
    'application/octet-stream': 'xlsx',  // Excel
    'application/msword': 'doc',  // Word
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',  // Word
    'application/pdf': 'pdf',  // PDF
    'image/jpeg': 'jpg',  // JPEG Image
    'image/png': 'png',  // PNG Image
    'image/gif': 'gif',  // GIF Image
    'audio/mpeg': 'mp3',  // MP3 Audio
    'video/mp4': 'mp4',  // MP4 Video
    'text/plain': 'txt',  // Plain Text
    'application/zip': 'zip',  // ZIP File
    'application/json': 'json',  // JSON File
  };
  
  export function getFileExtension(mimeType) {
    if (mimeTypeToExtension[mimeType]) {
      return mimeTypeToExtension[mimeType];
    } else {
      console.warn('MIME type not recognized');
      return '';
    }
  }